import React from "react";
import TimestampContext, { StringContextType } from "../context/timestampContext";

export const TimestampProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const [timestamp, setTimestamp] = React.useState<string>("");

    const value: StringContextType = { timestamp, setTimestamp };
    return (
        <TimestampContext.Provider value={value}>
            {children}
        </TimestampContext.Provider>
    );
};